/* eslint-disable @typescript-eslint/no-explicit-any */
import { MenuItem, TextField } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { camelCaseToHumanReadable } from "../../../helpers/utils";

export enum SpectraDevice {
  BlueSun = "BlueSun",
  Foss = "Foss",
  R60s = "R60s",
}

interface ISpectraDeviceSelectProps {
  label?: string;
  placeholder?: string;
  value?: SpectraDevice;
  onChange: (newVal?: SpectraDevice) => void;
  error?: boolean;
  helperText?: string;
  allowedDevices?: SpectraDevice[];
}
export default function SpectraDeviceSelect(props: ISpectraDeviceSelectProps) {
  const { t } = useTranslation();
  const { value, onChange, helperText, error, allowedDevices } = props;
  return (
    <TextField
      label={props.label}
      select
      fullWidth
      placeholder={t("Select Spectra Device")}
      helperText={helperText}
      error={error}
      value={value || ""}
      size="small"
      onChange={(e) => {
        onChange(e.target.value as unknown as SpectraDevice);
      }}
    >
      {Object.values(SpectraDevice).filter(d=>!allowedDevices || allowedDevices.includes(d)).map((device, i) => (
        <MenuItem key={`device-type-${i}`} value={device as SpectraDevice}>
          {camelCaseToHumanReadable(device)}
        </MenuItem>
      ))}
    </TextField>
  );
}
